import React from 'react';
import Step2Date from './Step2Date';
import Step3Time from './Step3Time';

const Step23AppointmentBooking = ({
  state,
  extAuth,
  isListingContact,
  currentStep,
  updateState,
  updateDate,
  $rootScope,
  UtilService,
  partialAutoConfirm,
  selectTime,
  setDuration,
  moveToStep,
  setCustomDuration,
  enableCustomDuration,
  hasValidTime,
  getPrettyDate,
  timePassed,
  expandTime,
}) => (
  <>
    <Step2Date
      {...state}
      state={state}
      isListingContact={isListingContact}
      currentStep={currentStep}
      updateState={updateState}
      updateDate={updateDate}
      $rootScope={$rootScope}
      UtilService={UtilService}
    />

    <Step3Time
      {...state}
      showingProviderAdditionalInfo={
        state.appointmentConfig?.showingProviderAdditionalInfo ??
        state.externalConfig?.showingProviderAdditionalInfo
      }
      extAuth={extAuth}
      isListingContact={isListingContact}
      partialAutoConfirm={partialAutoConfirm}
      updateDate={updateDate}
      updateState={updateState}
      currentStep={currentStep}
      selectTime={selectTime}
      setDuration={setDuration}
      moveToStep={moveToStep}
      setCustomDuration={setCustomDuration}
      enableCustomDuration={enableCustomDuration}
      hasValidTime={hasValidTime}
      getPrettyDate={getPrettyDate}
      timePassed={timePassed}
      expandTime={expandTime}
    />
  </>
);

export default Step23AppointmentBooking;
